module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/project/evaluate/assets/half-bright-star.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/project/evaluate/assets/half-bright-star.png
// module id = 1319
// module chunks = 418